// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".copyright[data-v-117e52e4]{font-size:.24rem;text-align:justify;padding:0 .2rem .2rem}.copyright p[data-v-117e52e4]{margin:1em 0}.copyright ol[data-v-117e52e4],.copyright ol li[data-v-117e52e4]{list-style-type:none;list-style-position:inside;margin:0;padding:0}.copyright ol li span[data-v-117e52e4]{color:red}.copyright ol li img[data-v-117e52e4]{width:100%;margin:.2rem auto}.copyright ol li.promise[data-v-117e52e4]{font-weight:700;font-size:.3rem}", ""]);
// Exports
module.exports = exports;
